import { render, staticRenderFns } from "./BusinessKindCard.vue?vue&type=template&id=2980647b&scoped=true&"
import script from "./BusinessKindCard.vue?vue&type=script&lang=js&"
export * from "./BusinessKindCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessKindCard.vue?vue&type=style&index=0&id=2980647b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980647b",
  null
  
)

export default component.exports